import useCategories from "../../../http/public/useCategories";
import Option from "../../../Models/forms/Option";

export default (selectedStandards: Option[]): Option[] => {
  const standardNames = selectedStandards.map((standard) => standard.label);
  return useCategories()
    .filter((category) => standardNames.includes(category.standardName))
    .map((category) => ({ label: category.name, value: category.externalId }));
};
